/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Suggest_Agent_QcInputs */



/**
* | output |
* | --- |
* | "QC my project and flag problems with event notes" |
*
* @param {Assistant_Suggest_Agent_QcInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_suggest_agent_qc = /** @type {((inputs?: Assistant_Suggest_Agent_QcInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Suggest_Agent_QcInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contrôle qualité de mon projet et signalement des problèmes dans les notes d'événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Qualitätskontrolle meines Projekts und Kennzeichnung von Problemen mit Ereignisnotizen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eseguo il controllo qualità del mio progetto e segnalo eventuali problemi con le note dell'evento.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проведите контроль качества моего проекта и отметьте проблемы в заметках о событиях.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Controla la calidad de mi proyecto e indica los problemas con las notas del evento.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检查我的项目，并在事件备注中标记问题。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトの品質管理を行い、イベントノートで問題点を報告します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेरे प्रोजेक्ट की गुणवत्ता की जांच करें और इवेंट नोट्स के माध्यम से समस्याओं को चिह्नित करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verifique a qualidade do meu projeto e sinalize problemas com as notas do evento.")
	return /** @type {LocalizedString} */ ("QC my project and flag problems with event notes")
});